import { marketingNavigation } from '../../../constants/marketing';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import MessageCampaignList from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignListScreen/components/MessageCampaignList/MessageCampaignList';
import MessageCampaignListHeader from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignListScreen/components/MessageCampaignListHeader/MessageCampaignListHeader';

const MessageCampaignsScreen = () => {
  return (
    <div className="d-flex flex-column flex-grow-1 position-relative">
      <ScreenHeader title="marketing_role" options={marketingNavigation()} />
      <MessageCampaignListHeader />
      <MessageCampaignList />
    </div>
  );
};

export default MessageCampaignsScreen;
